import { render, staticRenderFns } from "./LoaderCard.vue?vue&type=template&id=26f7c5b4&scoped=true&"
import script from "@/components/loader-card/LoaderCard.ts?vue&type=script&lang=ts&"
export * from "@/components/loader-card/LoaderCard.ts?vue&type=script&lang=ts&"
import style0 from "@/components/loader-card/loader-card.scss?vue&type=style&index=0&id=26f7c5b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f7c5b4",
  null
  
)

export default component.exports